import state from "./state";

export default {
    setRelatorioRede({ commit }, relatorio) {
        commit;
        state.relatorioRede = relatorio;
    }
};
